export default __webpack_public_path__ + "static/media/flag_red.7790818e.svg";